import {
  type ApolloClient,
  type NormalizedCacheObject,
  gql,
} from '@apollo/client';

type AssignPanelInput = {
  panelId: string;
  entries?: Array<{
    applicationId: string;
    netIds: string[];
  }>;
};

type AllocateResult = {
  applicationId: string;
  netIds: string[];
};
export const useGetAllocatePanel = async (
  client: ApolloClient<NormalizedCacheObject>,
  input: AssignPanelInput,
): Promise<AllocateResult[]> => {
  const { data } = await client.query({
    query: gql`
      query ($input: AssignPanelInput!) {
        queryPanelApplicationInitialAllocation(input: $input)
      }
    `,
    variables: { input },
    fetchPolicy: 'network-only',
  });

  return data.queryPanelApplicationInitialAllocation as AllocateResult[];
};
